module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7r6r5r1n-ce7a515ba548d5fb1f64a6145838e4c1.svg";